<template>
    <form @submit.prevent="submit" @keydown="errors.clear($event.target.name)">

        <base-input class="mb-3"
            :label="$t('xapi.common.agent-id')"
            :placeholder="$t('xapi.agents.id-placeholder')"
            required
            v-model="value.agent"
            name="agent"
            :error="errors.get('agent')">
        </base-input>

        <div class="category">{{ $t('common.examples') }}</div>
        <ul>
            <li><code>john@doe.com</code></li>
            <li><code>account:jdoe@http://lms.com</code></li>
            <li><code>openid:http://openid.org/12345</code></li>
            <li><code>sha1sum:cd9b00a5</code></li>
        </ul>

        <div class="category form-category mb-3">* {{ $t('common.required-fields') }}</div>

        <div class="buttons pt-2 text-center">
            <base-button type="primary" native-type="submit" :disabled="errors.any()">
                {{ $t('common.create') }}
            </base-button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                {{ $t('common.cancel') }}
            </button>
        </div>

    </form>
</template>

<script>
    export default {
        props: ['value', 'errors'],
        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
